module.exports = __webpack_public_path__ + "static/media/cplusplus.1fa13794.svg";